import { VegaFlex } from '@globalpayments/vega-react';

import { Card } from './CardProps';
import SessionCard from './SessionCard';

interface Props {
  cards: Card[];
  onCardClick: (appUid: string) => any;
}

const SessionCards: React.FC<Props> = ({ cards, onCardClick }) => {
  return (
    <VegaFlex direction="col" gap="size-16">
      {cards.map((card) => (
        <SessionCard key={card.appUid} card={card} onCardClick={onCardClick} />
      ))}
    </VegaFlex>
  );
};

export default SessionCards;
